export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/snapchat.3728075.svg";